// import apiClient from './apiClient';

// export const getTreatments = async () => {
//     try {
//         const response = await apiClient.get('/treatment/get_treatments');
//         return response.data;
//     } catch (error) {
//         throw error.response?.data || error.message;
//     }
// };

// export const getTreatmentById = async (id) => {
//     try {
//         const response = await apiClient.get(`/treatment/get_treatment/${id}`);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data || error.message;
//     }
// };

// export const getTreatmentsByAnimalId = async (animalId) => {
//     try {
//         const response = await apiClient.get(`/treatment/get_animal_treatments/${animalId}`);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data || error.message;
//     }
// };

// export const createTreatment = async (treatmentData) => {
//     try {
//         const response = await apiClient.post('/treatment/create_treatment', treatmentData);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data || error.message;
//     }
// };

// export const updateTreatment = async (id, treatmentData) => {
//     try {
//         const response = await apiClient.put(`/treatment/update_treatment/${id}`, treatmentData);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data || error.message;
//     }
// };

// export const deleteTreatment = async (id) => {
//     try {
//         const response = await apiClient.delete(`/treatment/delete_treatment/${id}`);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data || error.message;
//     }
// };

// src/api/treatment.js
import apiClient from './apiClient';

// ---- Paginated lists ----
export const getTreatments = async (
    {
        page = 1,
        pageSize = 10,
        search,
        sortBy = 'date',
        sortDir = 'desc',
        treatmentScope,
    } = {},
    tenantId = null
) => {
    try {
        const params = { page, page_size: pageSize, sort_by: sortBy, sort_dir: sortDir };
        if (search?.trim()) params.search = search.trim();
        if (treatmentScope) params.treatment_scope = treatmentScope;
        if (tenantId != null) params.tenant_id = tenantId;
        const res = await apiClient.get('/treatment/get_treatments', { params });
        return res.data; // { items, total, page, page_size, pages }
    } catch (error) {
        throw error?.response?.data || error.message;
    }
};

export const getTreatmentsByAnimalId = async (
    animalId,
    { page = 1, pageSize = 10 } = {},
    tenantId = null
) => {
    try {
        const params = { page, page_size: pageSize };
        if (tenantId != null) params.tenant_id = tenantId;
        const res = await apiClient.get(`/treatment/get_animal_treatments/${animalId}`, {
            params,
        });
        return res.data; // { items, total, page, page_size, pages }
    } catch (error) {
        throw error?.response?.data || error.message;
    }
};

export const getPrescribers = async (tenantId = null) => {
    try {
        const config = {};
        if (tenantId != null) config.params = { tenant_id: tenantId };
        const res = await apiClient.get('/treatment/prescribers', config);
        return Array.isArray(res.data) ? res.data : [];
    } catch (error) {
        throw error?.response?.data || error.message;
    }
};

// ---- Single / Mutations ----
export const getTreatmentById = async (id, tenantId = null) => {
    try {
        const config = {};
        if (tenantId != null) config.params = { tenant_id: tenantId };
        const res = await apiClient.get(`/treatment/get_treatment/${id}`, config);
        return res.data;
    } catch (error) {
        throw error?.response?.data || error.message;
    }
};

export const createTreatment = async (payload, tenantId = null) => {
    try {
        const config = {};
        if (tenantId != null) config.params = { tenant_id: tenantId };
        const res = await apiClient.post('/treatment/create_treatment', payload, config);
        return res.data;
    } catch (error) {
        throw error?.response?.data || error.message;
    }
};

// NOTE: backend updates by PK `id` (integer)
export const updateTreatment = async (id, payload, tenantId = null) => {
    try {
        const config = {};
        if (tenantId != null) config.params = { tenant_id: tenantId };
        const res = await apiClient.put(`/treatment/update_treatment/${id}`, payload, config);
        return res.data;
    } catch (error) {
        throw error?.response?.data || error.message;
    }
};

// (Only keep if your backend exposes a delete route later)
export const deleteTreatment = async (id, tenantId = null) => {
    try {
        const config = {};
        if (tenantId != null) config.params = { tenant_id: tenantId };
        await apiClient.delete(`/treatment/delete_treatment/${id}`, config);
    } catch (error) {
        throw error?.response?.data || error.message;
    }
};
